import {
  BOUNCE_REPORT,
  BRANCH_WISE_SALES_REPORT,
  DAILY_SALES_REPORT,
  DISCOUNT_ANALYSIS_REPORT,
  DOCTOR_WISE_SALES_REPORT,
  EXPIRY_LOSS_REPORT,
  CUSTOMER_PAYABLE,
  GSTR1_REPORT,
  GSTR20_REPORT,
  GSTR2A_REPORT,
  GSTR3B_REPORT,
  GSTR9C_REPORT,
  GSTR9_REPORT,
  GSTR_HSN_CODE_SUMMARY_REPORT,
  GST_E_WAY_BILL_REPORT,
  GST_ITC_AGING_REPORT,
  GST_ITC_MISMATCH_REPORT,
  GST_PAYMENT_SUMMARY_REPORT,
  INVENTORY_REPORT,
  INVENTORY_SALES_REPORT,
  OVERALL_SALES_REPORT,
  PARTY_WISE_PROFIT_REPORT,
  PARTY_WISE_SALES_REPORT,
  PAYMENT_MODE_WISE_SALES_REPORT,
  PRODUCT_WISE_SALES_REPORT,
  PURCHASE_BEHAVIOR_REPORT,
  PURCHASE_FREQ_REPORT,
  SALES_RETURN_REPORT,
  SCHEDULED_HDRUG_REG_REPORT,
  SLOW_FAST_MOVING_PRODUCTS,
  PRODUCT_PURCHASE_RETURN_REPORT,
  SAVED_REPORTS,
  SAVED_DATA_REPORTS,
  B2B_SALES_SUMMARY_REPORT,
  STORE_PURCHASE_REPORT,
  FAV_ITEMS,
  SET_FAV_ITEMS,
  PRODUCT_INFO_REPORT,
  PURCHASE_ORDER_REPORT,
  PROFIT_REPORT,
  VENDOR_MASTER,
  STOCK_LEDGER_BATCH,
  VENDOR_PAYABLE,
  DAY_WISE,
  REORDER_REPORT,
  ADD_TAGS,
  GET_TAGS,
  ADD_BOUNCE_REPORT
} from "../types";

/**Sales Reports */
export const overallSalesReportAction = (data, onSuccess, onError) => {
  return {
    type: OVERALL_SALES_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const DayWiseReportAction = (data, onSuccess, onError) => {
  return {
    type: DAY_WISE,
    data,
    onSuccess,
    onError,
  };
};


export const dailySalesReportAction = (data, onSuccess, onError) => {
  return {
    type: DAILY_SALES_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const branchWiseSalesReportAction = (data, onSuccess, onError) => {
  return {
    type: BRANCH_WISE_SALES_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const productWiseSalesReportAction = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_WISE_SALES_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const productPurchaseReturnReportAction = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_PURCHASE_RETURN_REPORT,
    data,
    onSuccess,
    onError,
  };
}

export const B2bSalesSummaryReportAction = (data, onSuccess, onError) => {
  return {
    type: B2B_SALES_SUMMARY_REPORT,
    data,
    onSuccess,
    onError,
  };
}

export const StorePurchaseReportAction = (data, onSuccess, onError) => {
  return {
    type: STORE_PURCHASE_REPORT,
    data,
    onSuccess,
    onError,
  };
}

export const ReorderReportAction = (data, onSuccess, onError) => {
  return {
    type: REORDER_REPORT,
    data,
    onSuccess,
    onError,
  };
}

export const GetSavedReportsAction = (data, onSuccess, onError) => {
  return {
    type: SAVED_REPORTS,
    data,
    onSuccess,
    onError
  }
}

export const AddTagsAction = (data, onSuccess, onError) => {
  return {
    type: ADD_TAGS,
    data,
    onSuccess,
    onError
  }
}

export const GetTagsAction = (data, onSuccess, onError) => {
  return {
    type: GET_TAGS,
    data,
    onSuccess,
    onError
  }
}

export const SavedReportDataAction = (data, onSuccess, onError) => {
  return {
    type: SAVED_DATA_REPORTS,
    data,
    onSuccess,
    onError
  }
}

export const GetFavAction = (data, onSuccess, onError) => {
  return {
    type: FAV_ITEMS,
    data,
    onSuccess,
    onError
  }
}

export const SetFavAction = (data, onSuccess, onError) => {
  return {
    type: SET_FAV_ITEMS,
    data,
    onSuccess,
    onError
  }
}

export const doctorWiseSalesReportAction = (data, onSuccess, onError) => {
  return {
    type: DOCTOR_WISE_SALES_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const partyWiseSalesReportAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_WISE_SALES_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const paymentModeWiseSalesReportAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_MODE_WISE_SALES_REPORT,
    data,
    onSuccess,
    onError,
  };
};

/**Financial and Revenue */
export const partyWiseProfitReportAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_WISE_PROFIT_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const discountAnalysisReportAction = (data, onSuccess, onError) => {
  return {
    type: DISCOUNT_ANALYSIS_REPORT,
    data,
    onSuccess,
    onError,
  };
};

/**Sales Return Reports */

export const salesReturnReportAction = (data, onSuccess, onError) => {
  return {
    type: SALES_RETURN_REPORT,
    data,
    onSuccess,
    onError,
  };
};

/**Customer */
export const purchaseFreqReportAction = (data, onSuccess, onError) => {
  return {
    type: PURCHASE_FREQ_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const purchaseBehaviorReportAction = (data, onSuccess, onError) => {
  return {
    type: PURCHASE_BEHAVIOR_REPORT,
    data,
    onSuccess,
    onError,
  };
};

/**Inventory and Slaes Reports */

export const bounceReportAction = (data, onSuccess, onError) => {
  return {
    type: BOUNCE_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const addBounceReportAction = (data, onSuccess, onError) => {
  return {
    type: ADD_BOUNCE_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const inventorySalesReportAction = (data, onSuccess, onError) => {
  return {
    type: INVENTORY_SALES_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const inventoryReportAction = (data, onSuccess, onError) => {
  return {
    type: INVENTORY_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const scheduledHDrugRegReportAction = (data, onSuccess, onError) => {
  return {
    type: SCHEDULED_HDRUG_REG_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const expiryLossReportAction = (data, onSuccess, onError) => {
  return {
    type: EXPIRY_LOSS_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const customerPayableReportAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_PAYABLE,
    data,
    onSuccess,
    onError,
  };
};

export const ProductInfoAction = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_INFO_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const slowAndFastMovingProductsReportAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: SLOW_FAST_MOVING_PRODUCTS,
    data,
    onSuccess,
    onError,
  };
};
// GST report

export const gstR1ReportAction = (data, onSuccess, onError) => {
  return {
    type: GSTR1_REPORT,
    data,
    onSuccess,
    onError,
  };
};
export const gstr2AReportAction = (data, onSuccess, onError) => {
  return {
    type: GSTR2A_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const gstr3bReportAction = (data, onSuccess, onError) => {
  return {
    type: GSTR3B_REPORT,
    data,
    onSuccess,
    onError,
  };
};
export const gstRHsnCodeSummaryReportAction = (data, onSuccess, onError) => {
  return {
    type: GSTR_HSN_CODE_SUMMARY_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const gstr9ReportAction = (data, onSuccess, onError) => {
  return {
    type: GSTR9_REPORT,
    data,
    onSuccess,
    onError,
  };
};
export const gstr9cReportAction = (data, onSuccess, onError) => {
  return {
    type: GSTR9C_REPORT,
    data,
    onSuccess,
    onError,
  };
};
export const gstItcMismatchReportAction = (data, onSuccess, onError) => {
  return {
    type: GST_ITC_MISMATCH_REPORT,
    data,
    onSuccess,
    onError,
  };
};
export const gstEWayBillReportAction = (data, onSuccess, onError) => {
  return {
    type: GST_E_WAY_BILL_REPORT,
    data,
    onSuccess,
    onError,
  };
};
export const gstPaymentSummaryReportAction = (data, onSuccess, onError) => {
  return {
    type: GST_PAYMENT_SUMMARY_REPORT,
    data,
    onSuccess,
    onError,
  };
};
export const gstItcAgingReportAction = (data, onSuccess, onError) => {
  return {
    type: GST_ITC_AGING_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const purchaseOrderReportAction = (data, onSuccess, onError) => {
  return {
    type: PURCHASE_ORDER_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const profitReportAction = (data, onSuccess, onError) => {
  return {
    type: PROFIT_REPORT,
    data,
    onSuccess,
    onError,
  };
};

export const vendorMasterReportAction = (data, onSuccess, onError) => {
  return {
    type: VENDOR_MASTER,
    data,
    onSuccess,
    onError,
  };
};

export const stockLedgerReportAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_LEDGER_BATCH,
    data,
    onSuccess,
    onError,
  };
};

export const vendorPayableAction = (data, onSuccess, onError) => {
  return {
    type: VENDOR_PAYABLE,
    data,
    onSuccess,
    onError,
  };
};
